import { isLinearAnswerItem } from '../../state-type-guards';
import type { StoreState } from '../../state-types';
import { makeSurveyDirty } from '../utils/make-survey-dirty';

/** Toggle an answer `isFreeForm`, which only be available in LinearAnswer */
export const toggleAnswerIsFreeForm =
    (answerId: string) =>
    (state: StoreState): StoreState => {
        const answer = state.answers[answerId];
        if (isLinearAnswerItem(answer)) {
            return makeSurveyDirty({
                ...state,
                answers: {
                    ...state.answers,
                    [answerId]: {
                        ...answer,
                        isFreeForm: answer.isFreeForm ? undefined : true,
                    },
                },
            });
        }

        return state;
    };
